import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const eventSetting = new Vuex.Store({
  state: {
    type: {},
    typeUploded: false,
    eventModel: {},
    guestEdit: null,
    showHeader: false
  },
  mutations: {
    setTypes (state, type) {
      state.type = type
    },

    setImageHeader (state, image) {
      state.eventModel.logo = image
      state.eventModel.path = 'https://s3.us-east-1.amazonaws.com/igotu_prod/v2/typeevent/custom/' + image
    },

    setShowHeader (state, show) {
      state.showHeader = show
    },

    setGuestEdit (state, guest) {
      state.guestEdit = guest
    },

    setGuests (state, newGuests) {
      // 1. Assicurati che newGuests sia trattato come un array (anche se è un singolo oggetto).
      const guestsToAdd = Array.isArray(newGuests) ? newGuests : (newGuests ? [newGuests] : [])

      // 2. Assicurati che state.eventModel e state.eventModel.guests esistano.
      if (!state.eventModel) {
        state.eventModel = {} // Crea eventModel se non esiste
      }

      const existingGuests = state.eventModel.guests || [] // Usa un array vuoto se non ci sono ancora ospiti

      // 3. Unisce gli ospiti esistenti e i nuovi ospiti
      state.eventModel.guests = [...existingGuests, ...guestsToAdd]

      // 4. Ordina la lista combinata per cognome (case-insensitive)
      state.eventModel.guests.sort((a, b) => {
        // Assicurati che cognome sia una stringa per evitare errori in localeCompare
        const surnameA = (a.surname || '').toLowerCase()
        const surnameB = (b.surname || '').toLowerCase()

        return surnameA.localeCompare(surnameB)
      })
    },

    reset (state) {
      state.type = {}
      state.typeUploded = false
      state.eventModel = {}
    },

    setTytpeUplodedUploded (state) {
      state.typeUploded = true
    },
    setEventModel (state, eventModel) {
      state.eventModel = eventModel
    },
    setStructure (state, json) {
      state.eventModel.event_labels = json
    },

    /**
     * MUTAZIONE CORRETTA: Aggiorna un guest esistente (sostituendolo) o lo aggiunge se è nuovo.
     * Questo risolve la duplicazione quando si aggiorna un guest (es. invio mail).
     */
    updateOrAddGuestToList (state, guest) {
      if (!state.eventModel.guests) {
        state.eventModel.guests = []
      }

      // 1. Cerca se il guest è già presente tramite il suo UID
      const existingGuestIndex = state.eventModel.guests.findIndex(
        g => g.uid === guest.uid
      )

      if (existingGuestIndex !== -1) {
        // AGGIORNAMENTO/SOSTITUZIONE: Sostituisce l'oggetto guest esistente con quello nuovo.
        // Usiamo Vue.set per garantire la reattività.
        Vue.set(state.eventModel.guests, existingGuestIndex, guest)
      } else {
        // AGGIUNTA: Non trovato, è un nuovo guest.
        state.eventModel.guests.push(guest)
      }

      // Riordina la lista dopo l'aggiunta o la modifica
      state.eventModel.guests.sort((a, b) => {
        const surnameA = a.surname || ''
        const surnameB = b.surname || ''
        return surnameA.localeCompare(surnameB)
      })
    },

    removeGuestFromList (state, guestUid, reload) {
      /* if (state.eventModel && Array.isArray(state.eventModel.guests)) {
        // Filtra l'array dei guest, rimuovendo quello con l'UID corrispondente
        state.eventModel.guests = state.eventModel.guests.filter(
          guest => guest.uid !== guestUid
        )
      } else {
        console.warn('Impossibile rimuovere il guest: eventModel.guests non è un array o non esiste.')
      } */

      if (reload) {
        state.eventModel.guests.sort((a, b) => {
          const surnameA = a.surname || ''
          const surnameB = b.surname || ''
          return surnameA.localeCompare(surnameB)
        })
      }
    }
  },
  actions: {

    showHeaderChange ({ commit }, show) {
      commit('setShowHeader', show)
    },

    reloadNewImage ({ commit }, img) {
      commit('setImageHeader', img)
    },

    /**
     * AZIONE CORRETTA: Chiama la mutazione universale di aggiornamento/aggiunta.
     */
    addGuestToEvent ({ commit }, guest) {
      commit('updateOrAddGuestToList', guest)
    },

    guestEdit ({ commit }, guest) {
      commit('setGuestEdit', guest)
    },
    uploadGuests ({ commit }, json) {
      commit('setGuests', json)
    },

    caricaType ({ commit }, json) {
      commit('setTypes', json)
      commit('setTytpeUplodedUploded')
    },
    resetEvents ({ commit }) {
      commit('reset')
    },
    setModel ({ commit }, json) {
      commit('setEventModel', json)
    },
    setStructureEventPax ({ commit }, json) {
      commit('setStructure', json)
    },
    deleteGuestFromEvent ({ commit }, guestUid, reload) {
      commit('removeGuestFromList', guestUid, reload)
    }

  },
  getters: {
    typeUploded: (state) => state.typeUploded,
    type: (state) => state.type,
    eventModel: (state) => state.eventModel,
    uidEvent: (state) => state.eventModel.uid,
    guests: (state) => state.eventModel.guests,
    idEvent: (state) => state.eventModel.id,
    nameEvent: (state) => state.eventModel.name,
    structure: (state) => state.eventModel.event_labels,
    guest: (state) => state.guestEdit,
    header: (state) => state.eventModel.path,
    showHeader: (state) => state.showHeader,
    hasMail: (state) => state.eventModel.has_mailer || false
  },
  plugins: [
    createPersistedState({
      key: 'SettingsStore',
      storage: window.localStorage,
      paths: [
        'type',
        'typeUploded',
        'eventModel',
        'showHeader',
        'editemail'
      ]
    })
  ]
})

export default eventSetting
